import { ADD_DOMAIN, ADD_DOMAIN_FAILED, ADD_DOMAIN_SUCCESS, BULKIMPORT_DOMAINS, BULKIMPORT_DOMAINS_FAILED, BULKIMPORT_DOMAINS_SUCCESS, DOMAIN_DELETE, DOMAIN_DELETE_FAILED, DOMAIN_DELETE_SUCCESS, GET_DOMAINS, GET_DOMAINS_FAILED, GET_DOMAINS_SUCCESS, GET_SAMPLE_DOMIANS_CSV, GET_SAMPLE_DOMIANS_CSV_FAILED, GET_SAMPLE_DOMIANS_CSV_SUCCESS, UPDATE_DOMAIN_SUCCESS } from "./actionTypes"

export const getDomainsData = (data) => {
    return {
        type:GET_DOMAINS,
        payload: {data}
    }
}

export const getDomainsDataSuccess = (data) => {
    return {
        type:GET_DOMAINS_SUCCESS,
        payload: {data}
    }
}

export const getDomainsDataFailed = (data) => {
    return {
        type:GET_DOMAINS_FAILED,
        payload: {data}
    }
}

export const domainDelete = (data) => {
    return {
        type:DOMAIN_DELETE,
        payload: {data}
    }
}

export const domainDeleteSuccess = (data) => {
    return {
        type:DOMAIN_DELETE_SUCCESS,
        payload: {data}
    }
}

export const domainDeleteFailed = (data) => {
    return {
        type:DOMAIN_DELETE_FAILED,
        payload: {data}
    }
}

export const addDomain = (data) => {
    return {
        type:ADD_DOMAIN,
        payload: {data}
    }
}

export const addDomainSuccess = (data) => {
    return {
        type:ADD_DOMAIN_SUCCESS,
        payload: {data}
    }
}

export const addDomainFailed = (data) => {
    return {
        type:ADD_DOMAIN_FAILED,
        payload: {data}
    }
}

export const updateDomainSuccess = (data) => {
    return {
        type:UPDATE_DOMAIN_SUCCESS,
        payload: {data}
    }
}

export const getSampleDomainCsv = () => {
    return {
        type:GET_SAMPLE_DOMIANS_CSV,
        
    }
}

export const getSampleDomainCsvSuccess = (data) => {
    return {
        type:GET_SAMPLE_DOMIANS_CSV_SUCCESS,
        payload: data
    }
}

export const getSampleDomainCsvFailed = (data) => {
    return {
        type:GET_SAMPLE_DOMIANS_CSV_FAILED,
        payload: data
    }
}

export const bulkImportDomains= (data) => {
    return {
        type:BULKIMPORT_DOMAINS,
        payload: data
    }
}

export const bulkImportDomainsSuccess= (data) => {
    return {
        type:BULKIMPORT_DOMAINS_SUCCESS,
        payload: data
    }
}

export const bulkImportDomainsFailed= (data) => {
    return {
        type:BULKIMPORT_DOMAINS_FAILED,
        payload: data
    }
}